import { Deserializable } from "./deserializable";

export class CartItemSummary {
    experienceName: string;
    eventDate: Date;
    eventPerformerExperienceId: number;
    eventPerformerName: string;
    eventName: string;
    quantity: number;
    totalAmount: number;
    maxPurchaseLimit: number;

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
      }
}



// WEBPACK FOOTER //
// ./src/app/_models/cart-item-summary.ts